import React from 'react';
import { Container } from 'react-bootstrap';
import AppRoutes from './routes/AppRoutes';

function App() {

  return (
    <Container fluid={true} className="p-0">
      <AppRoutes />
    </Container>
  );
}

export default App;
